import { MoonIcon, SunIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";

export default function ThemeToggler() {
  const [theme, setTheme] = useState(() => {
    const theme = localStorage.getItem("theme");
    return theme ? theme : "dark";
  });

  const toggleTheme = () => {
    let newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
  };

  useEffect(() => {
    const html = document.querySelector("html") as any;
    html.setAttribute("data-theme", theme);
    html.className = theme;
    
  }, [theme]);

  return (
    <label className={`swap  swap-rotate mr-2 `}>
      <input onClick={toggleTheme} type="checkbox" />
      {theme === "dark" ? (
        <SunIcon className={`fill-current h-8 `}></SunIcon>
      ) : (
        <MoonIcon className={`fill-current h-8 `}></MoonIcon>
      )}
    </label>
  );
}
